import { createSelector } from 'reselect';
import { KEY, HardwareState } from './types';
import { GlobalState } from 'store/types';
import { selectors as kioskSelectors } from 'services/kiosk/selectors';
import { NOT_CONNECTED, ERROR } from 'constants/hardware';

const getHardwareState = (state: GlobalState) => state[KEY] as HardwareState;

const selectPrinters = createSelector(getHardwareState, (hardware) => hardware.printers);

const selectScanner = createSelector(getHardwareState, (hardware) => hardware.scanner);

const selectPaymentDevice = createSelector(getHardwareState, (hardware) => hardware.paymentDevice);

const selectEventData = createSelector(getHardwareState, (hardware) => hardware.eventData);

const selectPrintData = createSelector(getHardwareState, (hardware) => hardware.printData);

const selectAllStatuses = createSelector(
  getHardwareState,
  kioskSelectors.selectPaymentHardware,
  kioskSelectors.selectScannerHardware,
  (hardware, paymentHardware, scannerHardware) =>
    hardware &&
    Object.keys(hardware).reduce((acc, key) => {
      if (
        (key === 'scanner' && scannerHardware) ||
        (key === 'paymentDevice' && paymentHardware) ||
        key === 'eventData'
      ) {
        return acc.concat(hardware[key].status.code);
      } else if (key === 'printers' && hardware[key].length) {
        return acc.concat(hardware[key].map((printer) => printer.status.code));
      }
      return acc;
    }, [] as string[])
);

const selectAnyHardwareErrors = createSelector(selectAllStatuses, (statuses) =>
  statuses.some((status) => [ERROR, NOT_CONNECTED].includes(status))
);

export const selectors = {
  selectPrinters,
  selectScanner,
  selectPaymentDevice,
  selectEventData,
  selectPrintData,
  selectAllStatuses,
  selectAnyHardwareErrors
};
